import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Slider
 } from 'components';
import { Modal } from 'react-bootstrap';

const CallLimitPopup = ({ isOpenModal, closeModal, isData, confirmAction, max }) => {
  const intl = useIntl();
  const [numberLimit, setNumberLimit] = useState(0);

  return (
    <Modal show={isOpenModal} onHide={closeModal} className="modal-member">
      <Modal.Header closeButton>
        <Modal.Title>
          {isData ? <FormattedMessage id='IDS_TV_GIOI_HAN_DATA' /> : <FormattedMessage id='IDS_TV_GIOI_HAN_THOAI' />}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="modal-member__limit-content">
          <Slider
            setValueSlider={(value) => setNumberLimit(value)}
            value={numberLimit}
            max={max}
            unit={isData ? 'MB' : intl.formatMessage({ id: 'IDS_TV_NUMBER_PHUT' })}
          />
        </div>
        <div className="modal-member__btn-wrapper display-center mt-5 mb-4">
          <Button onClick={closeModal}>
            <FormattedMessage id='IDS_SHUYDV' />
          </Button>
          <Button buttonClass="mr-3" onClick={() => confirmAction(numberLimit)}>
            <FormattedMessage id='IDS_TV_CONFIRM' />
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default React.memo(CallLimitPopup);